module.exports = __webpack_public_path__ + "static/img/mobile-load.bd06a21.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/statics/mobile-load.gif
// module id = O/Y4
// module chunks = 1